import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout/index'

Vue.use(Router)
const clauseRouter =[
  {
    path: '/',
    component: Layout,
    redirect: 'home',
    children: [
    {
      path: '/fwtk',
      component: () => import('@/views/clause/fwtk'),//服务条款
      name: 'fwtk'
    },
    {
      path: '/yssm',
      component: () => import('@/views/clause/yssm'),//隐私
      name: 'yssm'
    }

    ]
	}
]

export default clauseRouter



// WEBPACK FOOTER //
// ./src/router/clause.js